export enum DialogFooterActions {
  ADD = 'add',
  SAVE = 'save',
  SUBMIT = 'submit',
  SEND = 'send',
  CANCEL = 'cancel',
  DELETE = 'delete'
}
